import React, { useCallback, useEffect, useState } from "react";
import { Button, Col, Form, Input, Radio, RadioChangeEvent, Row, Select, Space } from "antd";

import AddressMaker, { AddressType } from "./AddressMaker";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";

import * as String from "../commons/string";
import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterCarModel({
    editMode,
    carModel,
    onRegisterCarModel,
}: {
    editMode: string;
    carModel?: Types.CarModelDto;
    onRegisterCarModel?: () => void;
}) {
    const [form] = Form.useForm();
    const alert = useAlert();

    const [modelId, setModelId] = useState("");
    const [modelName, setModelName] = useState("");
    const [unavailable, setUnavailable] = useState("");
    const [categoryId, setCarCategoryId] = useState(0);

    const requestAxiosAddCarModel = async (data: Types.CarModelDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().post(Request.CAR_MODEL_URL, data);

        return response.data;
    };

    const {
        loading: loadingAddCarModel,
        error: errorAddCarModel,
        data: resultAddCarModel,
        execute: requestAddCarModel,
    } = useAsyncAxios(requestAxiosAddCarModel);

    useEffect(() => {
        if (carModel === undefined) return;

        form.setFieldsValue(carModel);

        form.setFieldsValue({
            categoryId: carModel.category.categoryId,
        });
        setCarCategoryId(carModel.category.categoryId);
    }, [carModel]);

    useEffect(() => {
        if (resultAddCarModel === null) return;

        if (onRegisterCarModel) onRegisterCarModel();

        alert.setAlert(AlertType.SUCCESS, "모델 추가 성공", "모델 추가를 완료하였습니다.");
    }, [resultAddCarModel]);

    useEffect(() => {
        if (errorAddCarModel === null) return;

        console.log("errorCarModel", errorAddCarModel);
        alert.setAlert(errorAddCarModel.response.data.code, "모델 추가 실패", errorAddCarModel.response.data.message);
    }, [errorAddCarModel]);

    const requestAxiosUpdateCarModel = async (data: Types.CarModelDto) => {
        //console.log("data : " + data);

        const response = await utilAxiosWithAuth().put(Request.CAR_MODEL_URL + "/" + data.modelId, data);

        return response.data;
    };

    const {
        loading: loadingUpdateCarModel,
        error: errorUpdateCarModel,
        data: resultUpdateCarModel,
        execute: requestUpdateCarModel,
    } = useAsyncAxios(requestAxiosUpdateCarModel);

    useEffect(() => {
        if (resultUpdateCarModel === null) return;

        if (onRegisterCarModel) onRegisterCarModel();

        alert.setAlert(AlertType.SUCCESS, "모델 수정 성공", "모델 수정을 완료하였습니다.");
    }, [resultUpdateCarModel]);

    useEffect(() => {
        if (errorUpdateCarModel === null) return;

        console.log("errorUpdateCarModel", errorUpdateCarModel);
        alert.setAlert(errorUpdateCarModel.response.data.code, "모델 수정 실패", errorUpdateCarModel.response.data.message);
    }, [errorUpdateCarModel]);

    const onFinish = (values: any) => {
        delete values["confirm"];
        delete values["categoryId"];
        const data: Types.CarModelDto = {
            ...values,
            category: {
                categoryId: categoryId,
                categoryName: "",
                unavailable: false,
            },
        };
        console.log("Received values of form: ", data);

        if (editMode === "add") requestAddCarModel(data);
        else if (editMode === "update") requestUpdateCarModel(data);
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="modelId" label="모델 ID">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="modelName"
                                label="모델 이름"
                                rules={[
                                    {
                                        required: true,
                                        message: "모델 이름을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="모델 이름을 입력해 주세요." onChange={(e) => setModelName(e.target.value)} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="categoryId"
                                label="카테고리 ID"
                                rules={[
                                    {
                                        required: true,
                                        message: "카테고리 ID를 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="카테고리 ID를 입력해 주세요." onChange={(e) => setCarCategoryId(Number(e.target.value))} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="unavailable" label="비활성화">
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RegisterCarModel;
